import { Component, OnInit } from "@angular/core";
import { SharedService } from "../../../component/shared/shared.service";
import { User } from "../../user/model/user";
import { UserService } from "../../user/service/user.service";
import { Appointment, Schedule } from "../../appointment/model/appointment";
import { AppointmentService } from "../../appointment/service/appointment.service";
import { ActivatedRoute } from "@angular/router";
import { IMyDpOptions, IMyDateModel, IMyDate } from "mydatepicker";

@Component({
  selector: "app-mytransaction",
  templateUrl: "./mytransaction.component.html",
  styleUrls: ["./mytransaction.component.css"]
})
export class MytransactionComponent implements OnInit {
  isBooked: boolean = false;
  isPending: boolean = false;
  isDoctor: boolean = false;
  isBda: boolean = false;
  isAll: boolean = false;
  appointments: Appointment[];
  Users: User[];
  user: any;
  isAdmin = false;
  private sub: any;
  startDate: string = "";
  endDate: string = "";
  myDatePickerOptions: IMyDpOptions = {
    // other options...
    dateFormat: "dd/mm/yyyy"
  };
  start: Object = {};
  end: Object = {};
  option: string = "All";
  doctorId = "0";
  isVisible = false;
  constructor(
    private _sharedService: SharedService,
    private route: ActivatedRoute,
    private _usrService: UserService,
    private _appSrv: AppointmentService
  ) {
    let d = new Date();
    this.start = d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();
    this.end = d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();
  }

  getUserList() {
    this._usrService.getUsersList().subscribe(data => {
      this.Users = data.filter(
        usr => usr.UserRoleId == 2 && usr.IsDeleted == 0 && usr.UserActive == 1
      );
    });
  }

  ngOnInit() {
    this.user = JSON.parse(sessionStorage.getItem("User"));
    this.Users = [];
    var id: any;
    let d = new Date();
    this.startDate =
      d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();
    this.endDate =
      d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();

    this.getAllCompletedAppointment(this.startDate, this.endDate);
    if (this.user.UserRoleId == 1) {
      this.isAdmin = true;
    }

    this.getUserList();
    this._sharedService.paidTransactionAction$.subscribe(data => {
      this.submitPayment(data);
    });
  }

  showData() {
    this.appointments = [];

    this.showCompletedList();
  }
  getAllAppointment(startdate: string, enddate: string) {
    this._appSrv.getAllAppointment(startdate, enddate).subscribe(
      data => {
        if (parseInt(this.doctorId) !== 0) {
          this.appointments = data.filter(
            item => item.AppointmentDoctorId === parseInt(this.doctorId)
          );
        } else {
          this.appointments = data;
        }
      },
      error => {}
    );
  }
  showCompletedList() {
    if (this.startDate != "" && this.endDate != "") {
      this.getAllCompletedAppointment(this.startDate, this.endDate);
    }
  }

  getAllCompletedAppointment(startdate: string, enddate: string) {
    this._appSrv.GetAllTransaction(startdate, enddate).subscribe(
      data => {
        if (parseInt(this.doctorId) !== 0) {
          this.appointments = data.filter(
            item => item.AppointmentDoctorId === parseInt(this.doctorId)
          );
        } else {
          this.appointments = data;
        }
      },
      error => {}
    );
  }

  ngAfterViewChecked() {
    this._sharedService.emitChange(false);
  }
  ngOnDestroy() {
    this._sharedService.emitChange(true);
  }
  onDateChanged(event: IMyDateModel) {
    //debugger;

    if (event.date != null && event.date.year != 0) {
      this.startDate =
        event.date.year + "-" + event.date.month + "-" + event.date.day;
    } else {
      this.startDate = "";
      //this.message = 'Please select appointment date!';
      //this.isErrorMessage = true;
      return;
    }
  }
  onDateEndChanged(event: IMyDateModel) {
    //debugger;

    if (event.date != null && event.date.year != 0) {
      this.endDate =
        event.date.year + "-" + event.date.month + "-" + event.date.day;
    } else {
      this.endDate = "";
      //this.message = 'Please select appointment date!';
      //this.isErrorMessage = true;
      return;
    }
  }

  setVisibility() {
    this.isVisible = false;
    if (this.appointments.some(item => item["isCheck"] === true)) {
      this.isVisible = true;
    }
  }

  ApproveRefund(app: Appointment) {
    this._appSrv.ApproveCancelOrder(app.OrderNo).subscribe(
      data => {
        app.IsRefundRequired = false;
      },
      error => {}
    );
  }

  setToPay() {
    const paidData = this.appointments.filter(item => item["isCheck"] === true);
    this._sharedService.overlay({
      module: "USER",
      type: "PaidTrans",
      isShow: true,
      data: paidData,
      secondData: null
    });
  }

  submitPayment(data: any) {
    if (data.transactionId) {
      const req = [];
      let amt = data.amount;

      const transid = data.transactionId;
      data.data.forEach(element => {
        if (element.Amount <= amt) {
          amt = amt - element.Amount;
          req.push({
            TransactionId: transid,
            TotalAmount: data.amount,
            Amount: element.Amount,
            AppointmentId: element.AppointmentId,
            UserId: element.AppointmentDoctorId,
            UserName: element.AppointmentDoctorName,
            OrderId: element.OrderNo
          });
        } else {
          req.push({
            TransactionId: transid,
            TotalAmount: data.amount,
            Amount: amt,
            AppointmentId: element.AppointmentId,
            UserId: element.AppointmentDoctorId,
            UserName: element.AppointmentDoctorName,
            OrderId: element.OrderNo
          });
        }
      });
      this._appSrv.savePayment(req).subscribe(item => {
        this.showCompletedList();
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/section/user/mytransaction/mytransaction.component.ts